// extracted by mini-css-extract-plugin
export default {"items":"items-URgz","item":"item-aFdB"};